module.exports = __webpack_public_path__ + "static/media/backArrowDesktop.f60e186c.svg";